import { createRouter, createWebHashHistory } from 'vue-router'

import Home from '@/views/HomeView.vue'
import Intro from '@/views/IntroPage.vue'
import Products from '@/views/ProductsPage.vue'
import News from '@/views/NewsPage.vue'
import Contact from '@/views/ContactPage.vue'

const routes = [
  { path: '/home', name: 'HomeView', component: Home },
  { path: '/intro', name: 'IntroPage', component: Intro },
  { path: '/products', name: 'ProductsPage', component: Products },
  { path: '/news', name: 'NewsPage', component: News },
  { path: '/contact', name: 'ContactPage', component: Contact },
  { path: '/', redirect: '/home' } // 默认跳转到首页
]

const router = createRouter({
  history: createWebHashHistory(), // 👈 使用 Hash 模式，刷新不报错
  routes,
})

export default router
